export default __webpack_public_path__ + "static/media/MMP_BB_WholeLife Guide_2025.5f70a3e1.pdf";